module.exports = __webpack_public_path__ + "img/gb-eng.2d5bac56.svg";